import React, { useEffect, useState } from "react";
import { Input, Spin } from "antd";
import { Guardian, GuardianUpdatePayload } from "../../../../types/guardianTypes";
import { useTranslation } from "react-i18next";
import CustomModal from "../../../Common/CustomModal";
import SelectLinkedStudents from "./SelectLinkedStudents";

interface EditGuardianModalProps {
  open: boolean;
  guardian: Guardian;
  onClose: () => void;
  onSave: (payload: GuardianUpdatePayload) => Promise<void>;
}
const EditGuardianModal: React.FC<EditGuardianModalProps> = ({ open, guardian, onClose, onSave }) => {
  const { t } = useTranslation();

  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const [studentIds, setStudentIds] = useState<string[]>([]);
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    if (open) {
      setFormValues({
        firstName: guardian.user.firstName,
        lastName: guardian.user.lastName,
        email: guardian.user.email,
        phoneNumber: guardian.user.phoneNumber ?? "",
      });
      setStudentIds(guardian?.linkedStudents?.map((g) => g.id) || []);
    }
  }, [guardian, open]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setSaving(true);
    const payload: GuardianUpdatePayload = {
      // user:  { ...formValues },
      studentIds,
    };

    try {
      await onSave(payload);
    } finally {
      setSaving(false);
    }
  };

  return (
    <CustomModal
      title={t("edit_guardian")}
      isOpen={open}
      onClose={onClose}
      onSave={handleSubmit}
      loading={saving}
      saveText={t("save_changes")}
      width="700px"
    >
      <Spin spinning={false}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">{t("first_name")}</label>
            <Input
              name="firstName"
              value={formValues.firstName}
              onChange={handleChange}
              placeholder={t("enter_first_name")}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">{t("last_name")}</label>
            <Input
              name="lastName"
              value={formValues.lastName}
              onChange={handleChange}
              placeholder={t("enter_last_name")}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">{t("email")}</label>
            <Input
              name="email"
              value={formValues.email}
              onChange={handleChange}
              placeholder={t("enter_email")}
              disabled
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">{t("phone")}</label>
            <Input
              name="phoneNumber"
              value={formValues.phoneNumber}
              onChange={handleChange}
              placeholder={t("enter_phone_number")}
              disabled
            />
          </div>
          <div className="col-md-12 mb-3">
            <label className="form-label">{t("students")}</label>
            <SelectLinkedStudents value={studentIds} onChange={setStudentIds} initialStudents={guardian.linkedStudents}/>
          </div>
        </div>
      </Spin>
    </CustomModal>
  );
};

export default EditGuardianModal;
